/** @jsxImportSource @emotion/react */

import moment from "moment";
import { v7 as uuidv7 } from "uuid";
import Typography from "@mui/material/Typography";

import { cell, monthGrid } from "../../shared/styles/useDatePickerStyles";
import { monthBubble } from "../DayRangePicker/dayRangePickerStyles";
import { MonthHeaderViewProps } from "../DayRangePicker/types";

const MonthSelectView = ({
  year,
  month: selectedMonth,
  minDate,
  maxDate,
  onMonthSelect
}: MonthHeaderViewProps) => {
  const months = moment.localeData().monthsShort();
  const now = new Date();

  const isMonthDisabled = (monthIndex: number): boolean => {
    if (minDate && year < minDate.year()) return true;
    if (maxDate && year > maxDate.year()) return true;
    if (year === minDate?.year() && monthIndex < minDate.month()) return true;
    if (year === maxDate?.year() && monthIndex > maxDate.month()) return true;
    return false;
  };

  return (
    <div css={monthGrid}>
      {months.map((monthLabel, monthIndex) => {
        const isSelected = monthIndex === selectedMonth;
        const isDisabled = isMonthDisabled(monthIndex);
        const isToday =
          monthIndex === now.getMonth() && year === now.getFullYear();

        return (
          <div key={`${uuidv7()}_month_cell`} css={cell}>
            <Typography
              variant="body1Medium"
              css={monthBubble({
                isSelected,
                isDisabled,
                isToday,
                isInRange: false
              })}
              onClick={() => !isDisabled && onMonthSelect(monthIndex)}
            >
              {monthLabel}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default MonthSelectView;
